import packageJson from '../../package.json';

export const environment = {
  production: false,
  enableGlobalSearch: true,
  apiHost: 'https://api-nv-migration-educator.cardinality.info/api',
  chatServer: 'https://api-pics-sandbox-dev.cardinalityai.xyz/socket.io',
  mstrURL: 'https://web-gamicrostrategy.cardinality.info/MicroStrategyLibrary',
  n8nWorflowUrl: 'https://n8n-nv-migration-educator.cardinality.info/',
  wso2ApiManager: 'https://3.208.126.176:9443',
  wso2EnterpriseIntegratorHost: 'https://3.208.126.176:9444',
  businessRulesHost: 'https://business-central.cardinality.info/business-central/kie-wb.jsp',
  KMS_URL: 'https://kms-frontend-qa.cardinality.info/?navigate=/pages/kms-user/videos&source=CW',
  LMS_URL: 'https://lms-frontend-qa.cardinality.info/#/user/292',
  formPath: 'jjis-oregon',
  priority: 1,
  organizationid: 1,
  applicationid: 1,
  referenceIDCache: [2, 3, 5, 9, 10, 12, 16, 17, 18, 19, 23, 24, 29, 30, 31, 35, 60, 63, 65, 109, 118, 119, 163],
  videoConferenceDomain: 'web-gacmsvideo.cardinality.info',
  ChatBot: 'https://rasa-chatbot.cardinality.info/',
  ChatBotNew: 'https://rasa-search.cardinality.info/api/',
  helpVideoNames: [
    'Design a page using PICS: Page Designer',
    'Create workflow using PICS: Workflow Designer',
    'Workflow Execution in PICS: Workflow Designer',
    'Create Dashboard using PICS: Dashboards & Reports builder'
  ],
  s3BucketUrl: '',
  cloud_service_base_url: 'https://w057yixms6.execute-api.us-east-1.amazonaws.com/dev',
  mstrUsername: 'orgeon_provider',
  mstrPassword: 'admin@2023',
  mstrProjectID: '536D07A04970382CA52070B391E01998',
  version: packageJson.version,
  retryIdle: 5,
  retryTimeout: 1,
  hostingPlatform:'aws',
  cardyaiChatEndpoint:'https://intent-ai-assistant-api.cardinality.info',
  frontEndDomain:'https://nv-migration-educator.cardinality.info',
  crypto_key:'1234567890abcdef0987654321ghijkl',
  crypto_iv: 'abcdef9876543210',
  usePlatformHeader: true
};